export default __webpack_public_path__ + "static/media/energetic-eficient-costa-rica.923fa9fe.png";